export default __webpack_public_path__ + "b299dae6ec36f38d42e5c8ba071cc772.png";